import { createFileRoute } from '@tanstack/react-router'

import { BackupsPage } from '@/pages/backups/BackupsPage'

export const Route = createFileRoute('/_authenticated/backups')({
  component: BackupsPage,
})
